import { h } from 'preact';
import { useEffect } from 'preact/hooks';
import { lazy, LocationProvider, ErrorBoundary, Router } from 'preact-iso';
import Helmet from 'preact-helmet';

import { routes } from './constants';
import { runAnalytics } from './analytics';

import { Layout } from './components/layout';

const About = lazy(() => import('./views/About'));
const Agents = lazy(() => import('./views/Agents'));
const AgentsForm = lazy(() => import('./views/AgentsForm'));
const ErrorView = lazy(() => import('./views/Error'));
const Hex = lazy(() => import('./views/Hex'));
const Homepage = lazy(() => import('./views/Homepage'));
const Join = lazy(() => import('./views/Join'));
const Legal = lazy(() => import('./views/Legal'));
const Licenses = lazy(() => import('./views/Licenses'));
const LienholderSupport = lazy(() => import('./views/LienholderSupport'));
const OldPrivacyPolicy = lazy(() => import('./views/OldPrivacyPolicy'));
const Pay = lazy(() => import('./views/Pay'));
const PrivacyForm = lazy(() => import('./views/PrivacyForm'));
const Reviews = lazy(() => import('./views/Reviews'));

const App = () => {
    const handleRoute = () => {
        if (typeof window !== 'undefined') {
            // Cross-domain cookies are a bit complicated, in particular, this will not work
            // on localhost testing by default: update your etc/hosts file to point
            // "app.localhost.com", "www.localhost.com" to localhost to make it work.
            // Will work on dev/staging/prod, as it sets the root cookie for withhugo.com
            const expires = new Date();
            expires.setTime(expires.getTime() + 1000 * 60 * 60 * 24 * 365 * 2);
            const domain = window.location.href.includes('localhost')
                ? 'localhost.com'
                : 'withhugo.com';
            if (window.location.search) {
                const querySearchParams = new URLSearchParams(window.location.search);
                if (querySearchParams.get('ref')) {
                    document.cookie = `signupCode=${querySearchParams.get(
                        'ref',
                    )}; expires=${expires.toUTCString()}; domain=${domain}`;
                }
                if (querySearchParams.get('quoteCode')) {
                    document.cookie = `quoteCode=${querySearchParams.get(
                        'quoteCode',
                    )}; expires=${expires.toUTCString()}; domain=${domain}`;
                }
                document.cookie = `utm_tracking=${btoa(
                    window.location.search,
                )}; expires=${expires.toUTCString()}; domain=${domain}`;
            }
            if (document.referrer) {
                const ref = new URL(document.referrer);
                const isHugoReferrer =
                    ref.hostname === 'withhugo.com' || ref.hostname.endsWith('.withhugo.com');
                if (!isHugoReferrer) {
                    document.cookie = `utm_referrer=${
                        ref.hostname
                    }; expires=${expires.toUTCString()}; domain=${domain}`;
                }
            }
            window.analytics.page();
        }
    };

    useEffect(() => {
        runAnalytics();
    }, []);

    return (
        <LocationProvider>
            <ErrorBoundary onError={(e) => console.log(e)}>
                <Layout>
                    <Helmet defaultTitle="Hugo Insurance" titleTemplate="Hugo Insurance | %s" />
                    <Router onRouteChange={handleRoute}>
                        <Homepage path={routes.HOMEPAGE} />

                        {/* secondary */}
                        <Pay path={routes.PAY} />

                        {/* tetriray */}
                        <About path={routes.ABOUT} />
                        <Join path={routes.JOIN} />
                        <Reviews path={routes.REVIEWS} />
                        <Agents path={routes.AGENTS} />
                        <AgentsForm path={routes.AGENTS_FORM} />
                        <Licenses path={routes.LICENSES} />
                        <LienholderSupport path={routes.LIENHOLDER_SUPPORT} />
                        <Hex path={routes.HEX} />
                        <Legal path={routes.LEGAL} />
                        <OldPrivacyPolicy path={routes.OLD_PRIVACY_POLICY} />
                        <PrivacyForm path={routes.PRIVACY_FORM} />
                        <ErrorView path={routes.ERROR} default />
                    </Router>
                </Layout>
            </ErrorBoundary>
        </LocationProvider>
    );
};

export default App;
